'use client';

import React from 'react';
import clsx from 'clsx';
import STYLE from './Video.module.scss';

export interface VideoPropType {
    src: string;
    className?: string;
    videoProps?: React.VideoHTMLAttributes<HTMLVideoElement>;
}

export const Video: React.FC<VideoPropType> = (props) => {
    const { src, className, videoProps } = props;

    return (
        <div className={clsx(STYLE.video, className)}>
            <video
                className={STYLE.videoInner}
                src={src}
                autoPlay
                muted
                loop
                playsInline
                {...videoProps}
            />
        </div>
    );
};
